import React from 'react';
import { banner4 } from '../assets/images';
import Image from "./designlayouts/Image"
import { useEffect } from 'react';

const Bannerbottom = () => {

  return (
    <div className="p-4 max-w-md mx-auto">
      <div className="">
      <Image imgSrc={banner4} />
      </div>
    </div>
  );
};

export default Bannerbottom;